// extracted by mini-css-extract-plugin
module.exports = {"button_wrapper":"button_wrapper-2pY_C","registrationForm_checkbox":"registrationForm_checkbox-2nul-","registrationForm_checkbox_checked":"registrationForm_checkbox_checked-1TP93"};